import { media, styled } from '@pulse-web-ui/theme';

export const LoadingContainer = styled.div`
  position: absolute;
  width: 248px;
  top: 50%;
  transform: translateY(-50%);
  box-sizing: border-box;
  padding: 24px;
  background: ${({ theme }) => theme.colors.surface.primary};
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  border-radius: calc(${({ theme }) => theme.common.radius} * 6);

  ${media.desktop} {
    width: 324px;
  }
`;
